import { ReactNode } from 'react';
import { OverlayTrigger, OverlayTriggerProps, Tooltip } from 'react-bootstrap';

interface TooltippedTextProps {
  tooltipContent?: ReactNode;
  children: ReactNode;
  placement?: OverlayTriggerProps['placement'];
  offset?: [number, number];
  tooltipClassName?: string;
  spanClassName?: string;
}

export const TooltippedText = ({
  tooltipContent,
  children,
  placement = 'top',
  offset = [0, 0],
  tooltipClassName,
  spanClassName,
}: TooltippedTextProps) => {
  if (!tooltipContent) {
    return <>{children}</>;
  }

  const renderTooltip = (props) => (
    <Tooltip {...props} className={tooltipClassName}>
      {tooltipContent}
    </Tooltip>
  );

  return (
    <OverlayTrigger offset={offset} placement={placement} overlay={renderTooltip}>
      <span className={spanClassName}>{children}</span>
    </OverlayTrigger>
  );
};
